export default {
  header: "Oups, une erreur inattendue s'est produite",
  text: 'Veuillez actualiser la page ou cliquer sur le bouton « Retour au menu » ci-dessous.',
  button: 'Retour au menu',
};
